export const generateId = () =>
  `${Math.floor(Math.random() * Math.floor(Number.MAX_SAFE_INTEGER))}`;
